<template>
  <!--  <v-container fluid>
      <v-row>
        <v-col cols="12">

        </v-col>
      </v-row>
    </v-container>-->

  <v-toolbar flat>
    <v-autocomplete class="float-left mr-5" label="国家" hide-details clearable multiple
                    :loading="countryLoading" :readonly="countryLoading"
                    :items="countries" v-model="filters.countries"
                    :search-input.sync="input.country" @change="input.country = null"/>

    <v-autocomplete class="float-left mr-5" label="运输方式" hide-details clearable multiple
                    :loading="trafficTypeLoading" :readonly="trafficTypeLoading"
                    :items="trafficTypes" v-model="filters.trafficTypes"
                    :search-input.sync="input.trafficType" @change="input.trafficType = null"/>

    <v-autocomplete class="float-left mr-5" label="渠道" hide-details clearable multiple
                    :loading="channelLoading" :readonly="channelLoading"
                    :items="channels" v-model="filters.channels"
                    :search-input.sync="input.channel" @change="input.channel = null"/>

    <v-autocomplete class="float-left mr-5" label="渠道类型" hide-details clearable multiple
                    :loading="channelTypeLoading" :readonly="channelLoading"
                    :items="channelTypes" v-model="filters.channelTypes"
                    :search-input.sync="input.channelType" @change="input.channelType = null"/>

    <v-autocomplete class="float-left mr-5" label="仓库" hide-details clearable multiple
                    :loading="repositoryLoading" :readonly="channelLoading"
                    :items="repositories" v-model="filters.repositories"
                    :search-input.sync="input.repository" @change="input.repository = null"/>

    <v-autocomplete class="float-left mr-5" label="供应商等级" hide-details clearable multiple
                    :items="levels" v-model="filters.levels"
                    :search-input.sync="input.level" @change="input.level = null"/>
    <slot/>
  </v-toolbar>
</template>

<script>
export default {
  name: "ProviderFilter",
  props: {
    filters: Object
  },
  computed: {
    countryLoading() {
      return this.loading.country
    },
    trafficTypeLoading() {
      return this.countryLoading || this.loading.trafficType
    },
    channelLoading() {
      return this.trafficTypeLoading || this.loading.channel;
    },
    channelTypeLoading() {
      return this.channelLoading || this.loading.channelType;
    },
    repositoryLoading() {
      return this.channelTypeLoading || this.loading.repository;
    },
  },
  data() {
    return {
      loading: {
        trafficType: true,
        country: true,
        channel: true,
        channelType: true,
        repository: true,
      },
      trafficTypes: [],
      countries: [],
      channels: [],
      channelTypes: [],
      repositories: [],
      input: {
        country: null,
        trafficType: null,
        channel: null,
        channelType: null,
        repository: null,
        level: null
      },
      levels: [3, 2, 1]
    }
  },
  methods: {
    getCountries() {
      this.loading.country = true

      this.$axios.get("/channel/countries").then(
          response => {
            this.loading.country = false
            this.filters.countries = null
            this.countries = response.data
            this.getTrafficTypes()
          }
      )
    },
    getTrafficTypes() {
      this.loading.trafficType = true
      let params = {}

      if (this.filters.countries) {
        params.countries = this.filters.countries
      }

      this.$axios.get("/channel/trafficTypes", {
        params,
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            this.loading.trafficType = false
            this.filters.trafficTypes = null
            this.trafficTypes = response.data
            this.getChannels()
          }
      )
    },
    getChannels() {
      this.loading.channel = true
      let params = {}
      if (this.filters.trafficTypes) {
        params.trafficTypes = this.filters.trafficTypes
      }

      if (this.filters.countries) {
        params.countries = this.filters.countries
      }

      this.$axios.get("/channel/channels", {
        params,
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            this.loading.channel = false
            this.filters.channels = null
            this.channels = response.data
            this.getChannelTypes()
          }
      )
    },
    getChannelTypes() {
      this.loading.channelType = true
      let params = {}
      if (this.filters.trafficTypes) {
        params.trafficTypes = this.filters.trafficTypes
      }

      if (this.filters.countries) {
        params.countries = this.filters.countries
      }

      if (this.filters.channels) {
        params.channels = this.filters.channels
      }

      this.$axios.get("/channel/channelTypes", {
        params,
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            this.loading.channelType = false
            this.filters.channelTypes = null
            this.channelTypes = response.data
            this.getRepositories()
          }
      )
    },
    getRepositories() {
      this.loading.repository = true
      let params = {}
      if (this.filters.trafficTypes) {
        params.trafficTypes = this.filters.trafficTypes
      }

      if (this.filters.countries) {
        params.countries = this.filters.countries
      }

      if (this.filters.channels) {
        params.channels = this.filters.channels
      }

      if (this.filters.channelTypes) {
        params.channelTypes = this.filters.channelTypes
      }

      this.$axios.get("/channel/repositories", {
        params,
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(
          response => {
            this.loading.repository = false
            this.filters.repositories = null
            this.repositories = response.data
          }
      )
    },
  },
  mounted() {
    this.getCountries()
    this.getTrafficTypes()
    this.getChannels()
    this.getChannelTypes()
    this.getRepositories()
  },
  watch: {
    'filters.countries'() {
      this.getTrafficTypes()
    },
    'filters.trafficTypes'() {
      this.getChannels()
    },
    'filters.channels'() {
      this.getChannelTypes()
    },
    'filters.channelTypes'() {
      this.getRepositories()
    },
  }
}
</script>

<style scoped>

</style>